module.exports = __webpack_public_path__ + "static/media/aspirinCommon.42bae57d.mp3";